export const headers = {
    'wiringListHeadersRegister':[
    {
        text: 'ID',
        value: 'id',
        width: 30,
        enabled: true
    },
    {
        text: 'Сумма',
        value: 'sum',
        enabled: true
    },
    {
        text: 'Проект',
        value: 'projectName',
        width: 70,
        enabled: true
    },
    {
        text: 'Тип проводки',
        value: 'type',
        enabled: true
    },
    {
        text: 'Способ оплаты',
        value: 'paymentMethod',
        enabled: true
    },
    {
        text: 'Год по бюджету',
        value: 'budgetYear',
        enabled: true
    },
    {
        text: 'Организация',
        value: 'organization',
        enabled: true
    },
    
    {
        text: 'Доход/расход - фонд - статья',
        value: 'typeDir',
        width: 250,
        enabled: true
    },
    {
        text: 'Ответственный',
        value: 'expert',
        enabled: true
    },
    {
        text: 'Договор',
        value: 'contract',
        enabled: false
    },
    {
        text: 'Комментарий',
        value: 'comment',
        width: 260,
        enabled: true,
    },
    {
        text: 'Дата создания',
        value: 'createDate',
        enabled: false
    },
    {
        text: 'Контрагент',
        value: 'contractor',
        enabled: true
    },
    {
        text: 'Дата оплаты',
        value: 'paymentDate',
        enabled: true
    },
    {
        text: 'Номер счёта',
        value: 'accountNumber',
        enabled: false
    },
    {
        text: 'Вклад',
        value: 'contribution',
        enabled: false
    },
    { 
        text: '', 
        value: 'actions', 
        sortable: false,
        enabled: true,
        reserved: true
    }
],
'wiringListHeadersProject':[
    {
        text: 'ID',
        value: 'id',
        width: 30,
        enabled: true
    },
    {
        text: 'Сумма',
        value: 'sum',
        enabled: true
    },
    {
        text: 'Проект',
        value: 'projectName',
        width: 70,
        enabled: false
    },
    {
        text: 'Тип проводки',
        value: 'type',
        enabled: true
    },
    {
        text: 'Способ оплаты',
        value: 'paymentMethod',
        enabled: true
    },
    {
        text: 'Год по бюджету',
        value: 'budgetYear',
        enabled: false
    },
    {
        text: 'Дата оплаты',
        value: 'paymentDate',
        enabled: true
    },
    {
        text: 'Организация',
        value: 'organization',
        enabled: true
    },
    
    {
        text: 'Доход/расход - фонд - статья',
        value: 'typeDir',
        width: 250,
        enabled: true
    },
    {
        text: 'Договор',
        value: 'contract',
        enabled: true
    },
    {
        text: 'Ответственный',
        value: 'expert',
        enabled: true
    },
    {
        text: 'Комментарий',
        value: 'comment',
        width: 260,
        enabled: true,
    },
    {
        text: 'Дата создания',
        value: 'createDate',
        enabled: false
    },
    {
        text: 'Контрагент',
        value: 'contractor',
        enabled: true
    },
    {
        text: 'Номер счёта',
        value: 'accountNumber',
        enabled: false
    },
    {
        text: 'Вклад',
        value: 'contribution',
        enabled: false
    },
    { 
        text: '', 
        value: 'actions', 
        sortable: false,
        enabled: true,
        reserved: true
    }
]
};

/**
 * Merge a persisted header layout (localStorage) onto the current defaults.
 * - column set + order + widths come from the defaults, so newly added
 *   columns (e.g. "Комментарий") always show up;
 * - per-column enabled/disabled is taken from the stored layout when that
 *   column still exists, so the user's show/hide choices are kept;
 * - stored columns that no longer exist in the defaults are dropped.
 */
export function resolveHeaders(storageKey, stored) {
    const defaults = JSON.parse(JSON.stringify(headers[storageKey] || []));
    if (!Array.isArray(stored) || !stored.length) return defaults;
    const storedByValue = {};
    for (const h of stored) storedByValue[h.value] = h;
    return defaults.map((d) => {
        const s = storedByValue[d.value];
        return s && typeof s.enabled === 'boolean' ? { ...d, enabled: s.enabled } : d;
    });
}